import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import Global from '../../store/global-selectors';
import * as Actions from '../../store/shipments/filtering/shipments.filtering.actions';
import ShippingFilterViewContainer from '../../components/filterview-list/filterview/shipping/saved-filterview-container';
import ShippingDefaultFilterViewContainer from '../../components/filterview-list/filterview/shipping/default-filterview-container';
import ShippingCustomFilterViewContainer from '../../components/filterview-list/filterview/shipping/custom-filterview-container';
import FilterViewList from './index';
import { useSelectedShippingViewId } from '../../pages/shipping-page/shipping-left-nav/shipping-left-nav-context';

const savedViewsForStatusSelector = createSelector(
  (savedFilterViews) => savedFilterViews,
  (_, currentGridViewId) => currentGridViewId,
  (savedFilterViews, currentGridViewId) => savedFilterViews.filter((view) => view.gridViewId === currentGridViewId),
);

const viewsToRenderSelector = createSelector(
  (defaultFilterView) => defaultFilterView,
  (_, savedFilterViews, currentGridViewId) => savedViewsForStatusSelector(savedFilterViews, currentGridViewId),
  (_, __, ___, customFilterView) => customFilterView,
  (defaultFilterView, savedViewsForStatus, customFilterView) => {
    const viewsToRender = [defaultFilterView, ...savedViewsForStatus];
    if (customFilterView) {
      viewsToRender.push(customFilterView);
    }
    return viewsToRender;
  },
);

const ShippingFilterviewListContainer = () => {
  const dispatch = useDispatch();
  const currentGridViewId = useSelectedShippingViewId();
  const savedFilterViews = useSelector(Global.selectShipmentsFilteringSavedFilterViews);
  const defaultFilterView = useSelector(Global.selectShipmentsFilteringDefaultFilterView);
  const customFilterView = useSelector(Global.selectShipmentsFilteringCustomFilterView);
  const activeFilterView = useSelector(Global.selectShipmentsFilteringActiveFilterView) || defaultFilterView;
  const filterViews = viewsToRenderSelector(defaultFilterView, savedFilterViews, currentGridViewId, customFilterView);
  const switchActiveFilterView = useCallback(
    (filterView) => {
      dispatch(Actions.switchActiveFilterView(filterView));
    },
    [dispatch],
  );

  return (
    <FilterViewList
      activeFilterViewId={activeFilterView.filterViewId}
      CustomFilterViewContainer={ShippingCustomFilterViewContainer}
      DefaultFilterViewContainer={ShippingDefaultFilterViewContainer}
      FilterViewContainer={ShippingFilterViewContainer}
      filterViews={filterViews}
      switchActiveFilterView={switchActiveFilterView}
    />
  );
};

export default React.memo(ShippingFilterviewListContainer);
